(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-dyo"]) return;
  try {
    
$(document).ready(function(){

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-home_gift-finder"] && !window.DesignMode) return;
  try {
    
jQuery('.gift-finder .links label').click(function() {
    var clicked = $(this).attr('data-for-id');

    $(this).parents('li').siblings('li').find('label.on').removeClass('on');
    $(this).addClass('on');
});

  } catch(e) { console.error(e); }
})();

})();
